import React from "react";
import { CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Rocket } from "lucide-react";

interface PaymentModalityHeaderProps {
  missionCount: number;
  totalDays: number;
}

export function PaymentModalityHeader({ missionCount, totalDays }: PaymentModalityHeaderProps) {
  return (
    <>
      <CardHeader className="pb-3">
        <CardTitle className="text-lg flex items-center gap-2">
          <Rocket className="w-5 h-5 text-primary" />
          Ajustement de l'équipe
        </CardTitle>
        <CardDescription>
          Personnalisez la taille de votre équipe dédiée selon votre budget mensuel.
        </CardDescription>
      </CardHeader>

      <div className="mx-6 bg-blue-50 rounded-lg p-3 border border-blue-200">
        <div className="text-sm text-blue-800">
          <strong>{missionCount}</strong> mission{missionCount > 1 ? "s" : ""} sélectionnée
          {missionCount > 1 ? "s" : ""} •<strong> {totalDays}</strong> jours de développement (hors
          options et gestion de projet)
        </div>
      </div>
    </>
  );
}

export default PaymentModalityHeader;
